// $(() => {
//     new typeBox();
// });


class typeBox {

    constructor() {

        this.val = null;
        this.$parent = $('#typeBox');
        this.list = '#typeBox-list';
        this.select = '#typeBox-select';
        this.select__items = '#typeBox-select__items';
        this.select__btn = '#typeBox-select__btn';
        this.select__label = '#typeBox-select__label';
        this.input = '#typeBox-text';
        this.$input = $(this.input);
        this.autocomplete = '#typeBox-autocomplete';
        this.data = this.loadData();
        this.wasDemoPalyed = false;
        this.infoBox = '#infoBox';
        this.$infoBox = $(this.infoBox);
        this.$infoBox__header = this.$infoBox.children('.infoBox-header');
        this.$infoBox__body = this.$infoBox.children('.infoBox-body');
        this.$infoBox__btn = this.$infoBox.children('.infoBox-btn');
        this.demoText = 'responzivní pro mobily a tablety';
        this.demoTimeOut = 8000;
        this.demoWaiting1 = null;
        this.demoWaiting2 = null;

        this.engine__insertData();

        this.search();
        this.select__events();
        this.keyboardNavigation__deActivate();
        this.typeBox__events();
        this.engine = this.search__init();
        this.demo__init();

        this.autocompleteList = [];


        this.$input.on('click', () => {
            this.demo__checkTimeOut();
        });
    }

    // load data from json
    loadData() {
        var request = new XMLHttpRequest();
        request.open("GET", "public/data/typeBox.json", false);
        request.send(null);
        return JSON.parse(request.responseText);
    }

    // init Jets
    search__init() {
        return new Jets({
            contentTag: this.list,
            callSearchManually: true,
            searchSelector: '*',
            didSearch: () => {
                this.search__bold();
            }
        });
    }

    // insert json dat to page
    engine__insertData() {
        const that = this;
        $(that.select__btn + '> span').text(that.demoText);
        this.data.forEach(function (item, index) {
            $('<li />', {'data-id': index,'data-question': item.question}).text(item.question).appendTo($(that.list));
            $('<li />', {'data-id': index,}).text(item.question).appendTo($(that.select__items));
        });
    }

    // show autocomplete and, remove placeholder
    typeBox__activate() {
        this.$parent.addClass('isActive');
        this.$input.addClass('isActive');
        this.typeBox__showAcutocomplete();
    }

    // hide autocomplete and, add placeholder
    typeBox__deActivate(complete = true) {
        this.$parent.removeClass('isActive');
        this.$input.removeClass('isActive');
        this.typeBox__hideAcutocomplete();

        if (complete) {
            $('body').attr('data-keyboard', true);
            this.keyboardNavigation__deActivate();
        }
    }

    // show autocomplete
    typeBox__showAcutocomplete() {
        $(this.autocomplete).addClass('isActive');
    }

    // hide autocomplete
    typeBox__hideAcutocomplete() {
        $(this.autocomplete).removeClass('isActive');
    }

    // show bold
    search__bold() {
        this.debug('test bold init');
        $(this.list).find('li').each((i, el) => {
            let item = $(el);
            if (item.css('display') !== 'none') {
                let find = $.trim(this.val);
                let oldText = item.attr('data-question');
                let newText = oldText.replace(find.toLowerCase(), "<strong>" + find.toLowerCase() + "</strong>").replace(find.toUpperCase(), "<strong>" + find.toUpperCase() + "</strong>");

                item.html(newText);
            }
        })
    }

    activate() {
        this.moveCaretToEnd(this.$input.get(0));
    }

    // manual search on change
    search() {
        this.$input.on('input', () => {

            if (this.wasDemoPalyed === false) {
                this.wasDemoPalyed = true;
            }

            this.val = this.$input.text();
            if (this.val.length) {
                this.engine.search(this.val);
                this.typeBox__activate();
                if (!this.$parent.hasClass('demo')) {
                    this.keyboardNavigation__init();
                }
            } else {
                this.typeBox__deActivate();
            }
        });

        this.$input.on('focus input', () => {
            this.keyboardNavigation__activate();
            $('body').attr('data-keyboard', false);
        });
    }

    search__checkAnswer() {
        let that = this;
        let activeIndex = that.keyboardNavigation__getActiveItem();
        let activeItem = that.autocompleteList[activeIndex];
        let index = parseInt(activeItem.data('id'));

        if (activeItem.length) {
            that.$input.text(activeItem.attr('data-question'));
            that.val = that.$input.text();
            that.moveCaretToEnd(that.$input.get(0));
            that.typeBox__hideAcutocomplete();

            setTimeout(function () {
                that.$parent.addClass('hasAnswer');
            }, 500);
            this.debug('check answer')

            that.answer__show(index)
        }
    }

    keyboardNavigation__init() {
        this.debug('add first item');
        this.keyboardNavigation__getList();

        if (this.autocompleteList.length > 0) {
            this.keyboardNavigation__activateItem(0);
        }
    }

    keyboardNavigation__resetList() {
        $(this.list).find('li').removeClass('isActive');
    }

    keyboardNavigation__activateItem(index) {
        this.keyboardNavigation__resetList();
        this.$parent.attr('data-activeItem', index);
        this.autocompleteList[index].addClass('isActive');
    }

    keyboardNavigation__getActiveItem() {
        let out = 0;
        if (typeof this.$parent.attr('data-activeItem') !== 'undefined') {
            out = parseInt(this.$parent.attr('data-activeItem'));
        }
        return out;
    }

    keyboardNavigation__moveNavigation(direction) {
        let current = this.keyboardNavigation__getActiveItem();
        let all = this.autocompleteList;
        let newPosition = null;

        if (direction === 'up') {
            if (current - 1 >= 0) {
                newPosition = current - 1;
            }
        } else {
            if (current + 1 < all.length) {
                newPosition = current + 1;
            }
        }

        if (newPosition !== null) {
            this.keyboardNavigation__activateItem(newPosition);
        }
    }

    keyboardNavigation__setNavigation(newPosition) {
        if (newPosition !== null) {
            this.keyboardNavigation__activateItem(newPosition);
        }
    }

    keyboardNavigation__activate() {
        this.$parent.attr('data-keyboard', true);
    }

    keyboardNavigation__deActivate() {
        this.$parent.attr('data-keyboard', false);
    }

    keyboardNavigation__isEnabled() {
        let out = false;
        if (typeof this.$parent.attr('data-keyboard') === 'undefined') {
            out = true;
        } else {
            if (this.$parent.attr('data-keyboard') === 'true') {
                out = true;
            } else {
                out = false;
            }
        }
        return out;
    }

    keyboardNavigation__getList() {
        let that = this;
        let items = [];
        $(that.list).find('li').each(function () {
            if ($(this).css('display') === 'block') {
                items.push($(this));
            }
        });
        that.autocompleteList = items;
    }

    typeBox__events() {
        let that = this;

        keyboardJS.bind(['up'], function (e) {
            if (that.keyboardNavigation__isEnabled()) {
                e.preventDefault();
                that.keyboardNavigation__moveNavigation('up');
                that.debug('up');
            }
        });

        keyboardJS.bind(['down'], function (e) {
            if (that.keyboardNavigation__isEnabled()) {
                e.preventDefault();
                that.keyboardNavigation__moveNavigation('down');
                that.debug('down');
            }
        });

        keyboardJS.bind(['enter'], function (e) {
            if (that.keyboardNavigation__isEnabled()) {
                e.preventDefault();
                that.debug('enter');
                that.search__checkAnswer();
            }
        });

        keyboardJS.bind([''], function (e) {
            if (that.keyboardNavigation__isEnabled() && that.$parent.hasClass('hasAnswer')) {
                e.preventDefault();
                let keyCode = e.keyCode;
                that.cleanInput(keyCode);
            }
        });

        $(that.list + ' li').on('click', function (e) {
            if (that.keyboardNavigation__isEnabled()) {
                e.preventDefault();
                let $item = $(this);
                let itemIndex = 0;

                that.autocompleteList.forEach(function (item, index) {
                    if (item.data('id') === $item.data('id')) {
                        itemIndex = index;
                    }
                });

                if ($item.css('display') === 'block') {
                    that.keyboardNavigation__setNavigation(itemIndex);
                    that.search__checkAnswer();
                }
            }
        });

        $(that.select__items + ' li').on('click', function (e) {
            e.preventDefault();
            let $item = $(this);
            let itemIndex = $item.data('id');

            that.select__control(true);
            that.select__activeItem($item);
            that.answer__hide(true);
            that.answer__show(itemIndex)
        });
    }

    cleanInput(keyCode) {
        let that = this;

        that.answer__hide();
        that.$input.text(null);
        that.val = '';
        that.$parent.removeClass('hasAnswer');
        that.typeBox__deActivate(false);
        that.$input.attr('contenteditable', true).focus();

        if (keyCode >= 65 && keyCode <= 90) {
            let keyName = String.fromCharCode(keyCode + 32);

            that.$input.text(keyName);
            that.val = keyName;
            that.engine.search(keyName);
            that.typeBox__activate();
            that.moveCaretToEnd(that.$input.get(0));

            if (!that.$parent.hasClass('demo')) {
                that.keyboardNavigation__init();
            }
        }

        that.debug('clean');
    }

    // type one text in the typwriter
    // keeps calling itself until the text is finished
    demo__typeWriter(text, i, fnCallback) {
        let that = this;
        // check if text isn't finished yet
        if (i < (text.length)) {

            let state = text.substring(0, i + 1);
            // add next character
            that.$input.text(state);
            that.val = that.$input.text();
            that.engine.search(that.val);

            // wait for a while and call this function again for next character
            that.demoWaiting2 = setTimeout(() => {
                    that.demo__typeWriter(text, i + 1, fnCallback)
                },
                Math.random() * 50
                // 10
            ); // call random timeout fol typing effect
        }
        // text finished, call callback if there is a callback function
        else if (typeof fnCallback == 'function') {
            // call callback after timeout
            that.demoWaiting2 = setTimeout(fnCallback, 700);
        }
    };

    //
    // // start a typewriter animation for a text in the dataText array
    demo__textAnimation(i, demoText, demoIndex) {
        let that = this;

        that.debug('start');
        that.$input.attr('contenteditable', false);
        that.$parent.addClass('demo');
        that.typeBox__activate();
        // start typewriter animation
        that.demo__typeWriter(demoText, 0, () => {
            // after callback (and whole text has been animated), start next text
            that.debug('finished');
            that.typeBox__hideAcutocomplete();
            that.answer__show(demoIndex);
            that.$parent.addClass('hasAnswer');

            that.demoWaiting1 = setTimeout(() => {
                that.demo__finish();
            }, that.demoTimeOut);
        });
    };

    demo() {
        let demoIndex = 0;
        // start the text animation
        this.demo__textAnimation(0, this.demoText, demoIndex);
    }

    // demo Event
    demo__init() {
        $('#typeBoxDemo').on('click', () => {
            this.debug('demo start');
            this.demo();
        });
    }

    moveCaretToEnd(el) {
        el.focus();
        let atStart = false;
        if (typeof window.getSelection != "undefined"
            && typeof document.createRange != "undefined") {
            var range = document.createRange();
            range.selectNodeContents(el);
            range.collapse(atStart);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
        } else if (typeof document.body.createTextRange != "undefined") {
            var textRange = document.body.createTextRange();
            textRange.moveToElementText(el);
            textRange.collapse(atStart);
            textRange.select();
        }
    }

    answer__hide(force = false) {
        let that = this;
        let speed = 400;

        if(force === true){
            speed = 0;
        }

        that.$infoBox__header.stop().fadeOut(speed);
        that.$infoBox__body.stop().fadeOut(speed);
        that.$infoBox__btn.stop().fadeOut(speed);
    }

    answer__show(index) {
        this.debug('show answer ' + index);
        let that = this;
        let question = that.data[index];
        let answer = question.answer;
        let hasButtonData = false;
        let wasButtonShowed = false;

        if (that.$infoBox.hasClass('hidden')) {
            that.$infoBox.removeClass('hidden');
        }

        // update button data and control animation
        if (answer.button.title !== null && answer.button.url !== null) {
            hasButtonData = true;

            that.$infoBox__btn
                .attr('href', answer.button.url)
                .attr('target', '_blank')
                .children('.in')
                .text(answer.button.title);

        } else {
            this.$infoBox__btn.stop().hide();
        }

        // update body data and control animation
        if (answer.body !== null) {
            that.$infoBox__body.stop().show().text('');
            let showButton = false;

            if (hasButtonData === true && wasButtonShowed === false) {
                wasButtonShowed = true;
                showButton = true;
            }

            that.answer__textAnimation(0, answer.body, that.$infoBox__body, 30, showButton)
        } else {
            that.$infoBox__body.stop().hide();
        }

        // update header data and control animation
        if (answer.header !== null) {
            that.$infoBox__header.stop().show().text('');
            let showButton = false;

            if (hasButtonData === true && wasButtonShowed === false) {
                wasButtonShowed = true;
                showButton = true;
            }

            that.answer__textAnimation(0, answer.header, that.$infoBox__header, 100, showButton)
        } else {
            that.$infoBox__header.stop().hide();
        }

        if (hasButtonData === true && wasButtonShowed === false) {
            wasButtonShowed = true;
            that.$infoBox__btn.stop().fadeIn().css('display', 'inline-block');
        }

        that.debug(answer);
    };

    // type one text in the typwriter
    // keeps calling itself until the text is finished
    answer__typeWriter(text, $elm, i, speed, fnCallback) {
        let that = this;
        // check if text isn't finished yet
        if (i < (text.length)) {

            let state = text.substring(0, i + 1);
            // add next character
            $elm.text(state);

            // wait for a while and call this function again for next character
            setTimeout(() => {
                    that.answer__typeWriter(text, $elm, i + 1, speed, fnCallback)
                },
                Math.random() * speed
                // 10
            ); // call random timeout fol typing effect
        }
        // text finished, call callback if there is a callback function
        else if (typeof fnCallback == 'function') {
            // call callback after timeout
            setTimeout(fnCallback, 200);
        }
    };

    //
    // // start a typewriter animation for a text in the dataText array
    answer__textAnimation(i, text, $elm, speed, showButton) {
        let that = this;

        // start typewriter animation
        that.answer__typeWriter(text, $elm, 0, speed, () => {
            if (showButton) {
                that.$infoBox__btn.fadeIn().css('display', 'inline-block');
            }
        });
    };

    debug(attr) {
        if (0) {
            console.log(attr);
        }
    }

    demo__checkTimeOut(){
        if (this.$parent.hasClass('demo')) {
            clearTimeout(this.demoWaiting1);
            clearTimeout(this.demoWaiting2);
            this.demo__finish();
        }
    }

    demo__finish(){
        let that = this;

        that.$parent.removeClass('demo');
        that.cleanInput(0);
    }

    select__events() {
        let that = this;

        // open or close on click to button
        $(that.select__btn).on('click', function () {
            that.demo__checkTimeOut();
            that.select__control();
        });

        // open or close on click to label
        $(that.select__label).on('click', function () {
            that.demo__checkTimeOut();
            that.select__control();

        });

        // close select on click on other element than select and its child's when is open
        $('body').on('click', function (e) {

            let target = $(e.target);
            if ($(that.select).hasClass('isActive')) { // only on open select
                if (!target.closest('.typeBox-select__container').length) { // check if exist parent
                    that.demo__checkTimeOut();
                    that.select__control(true); // force close select
                }
            }
        });
    }

    // open close select
    select__control(forceClose = false) {
        let that = this;
        let select = $(that.select);
        let activeClass = 'isActive';

        if (forceClose === true) {
            select.removeClass(activeClass);
        } else {
            if (select.hasClass(activeClass)) {
                select.removeClass(activeClass);
            } else {
                select.addClass(activeClass);
            }
        }
    }

    // activate item in select
    select__activeItem($item) {
        let activeClass = 'isActive';
        let select__btn = $(this.select__btn + ' > span');

        select__btn.text($item.text());
        $item.siblings().removeClass(activeClass);
        $item.addClass(activeClass);
    }
}